import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingSelectAllCheckboxClickedEventParams {
	enquiryIds: string[];
	isChecked: boolean;
}

export const triggerSellerMessagingSelectAllCheckboxClickedEvent = ({
	enquiryIds,
	isChecked,
}: TriggerSellerMessagingSelectAllCheckboxClickedEventParams): void => {
	const label = JSON.stringify({ [isChecked ? 'checked' : 'unchecked']: enquiryIds });

	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { label },
		name: 'dlr_seller_messaging_select_all_checkbox_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
